import { render, staticRenderFns } from "./Publico.vue?vue&type=template&id=6e76692c"
import script from "./Publico.vue?vue&type=script&lang=js"
export * from "./Publico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports